import { Component } from '@angular/core';

@Component({
  selector: 'kh-homework-loader',
  templateUrl: './homework-loader.component.html',
  styleUrls: ['./homework-loader.component.less'],
  standalone: false
})
export class HomeworkLoaderComponent { }
